import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type {
    MatchingFunction,
    TranslatableNameWithType,
    Value,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type {
    FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import {
    FilterType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import type UISignalDataDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDataDeps";
import filterNamingService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterNamingService";

function createCountriesNameFactory(): FilterNameResolver {
    return {
        buildName<F extends SignalFilters & { countries: readonly Value[] }>(
            filters: F,
            options: NonNullable<UISignalDataDeps["countries"]>,
            translationOptions = { i18nKeyModifier: FilterType.Countries },
        ): Readonly<TranslatableNameWithType> {
            const numberOfOptions = options.length;

            const matchValueToName: MatchingFunction = (value) => {
                const option = options.find(({ id }) => value === id);

                return option?.text;
            };

            return filterNamingService.buildNameForCountrySelection({
                values: filters.countries,
                numberOfOptions,
                matchValueToName,
                translationOptions,
            });
        },
    };
}

export default createCountriesNameFactory;
